import { Site } from 'src/models/Site.model';

import { DeviceDataView } from '../DeviceDataView.model';
import { SiteData } from '../Order.model';

const convertSiteData = (
  content: Array<DeviceDataView<SiteData>> | undefined,
): Site[] => {
  if (!content) return [];

  return content
    .map((item) => ({
      siteId: item.data.SiteId.value,
      siteName:
        item.data.SiteName.value.charAt(0).toUpperCase() +
        item.data.SiteName.value.slice(1),
    }))
    .sort((a, b) => a.siteName.localeCompare(b.siteName));
};

export { convertSiteData };
